// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f96ad5a","455":"53c0253c","977":"d5cc2134"}[chunkId] + ".chunk.js";
};